import { Commit } from 'vuex';
import { SuiviReclamationState } from './state';

export enum SuiviReclamationActions {
    GET_SUIVI_RECLAMATION = 'GET_SUIVI_RECLAMATION',
    GET_HISTORIQUE = 'GET_HISTORIQUE',
    GET_XLS_RECLAMATION = 'GET_XLS_RECLAMATION',
    SET_RECLAMATIONS_CONSULTEES = 'SET_RECLAMATIONS_CONSULTEES'
}

export interface SuiviReclamationActionTypes {
    commit: Commit;
    state: SuiviReclamationState;
    getters: any;
}
